<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'NewSlider'}"
                        class="btn btn-primary btn-round">
                    + New Slider
                </b-link>
            </template>
        </navbar>


        <template v-if="items.length > 0">
            <draggable v-model="items" group="items"
                       @update="updateOrder"
                       handle=".handle"
                       @start="drag=true"
                       @end="drag=false">
                <b-card v-for="(item,index) in items" :key="index">
                    <div class="table-responsive">
                        <b-table-simple>
                            <b-thead>
                                <b-tr>
                                    <b-th>desktop</b-th>
                                    <b-th>tablet</b-th>
                                    <b-th>mobile</b-th>
                                    <b-th>hide</b-th>
                                    <b-th>link</b-th>
                                    <b-th>action</b-th>
                                </b-tr>
                            </b-thead>

                            <b-tbody>
                                <b-tr>
                                    <b-td>
                                        <b-img :src="item.slider_image_url" width="120" height="120" placeholder="not-loading"></b-img>
                                    </b-td>
                                    <b-td>
                                        <b-img :src="item.slider_image_url_tablet" width="120" height="120" placeholder="not-loading"></b-img>
                                    </b-td>
                                    <b-td>
                                        <b-img :src="item.slider_image_url_mobile" width="120" height="120" placeholder="not-loading"></b-img>
                                    </b-td>
                                    <b-td>
                                        {{item.slider_is_hide}}
                                    </b-td>
                                    <b-td>
                                        <a target="_blank" :href="item.slider_link">{{item.slider_link}}</a>
                                    </b-td>
                                    <b-td>
                                        <b-link class="btn btn-info"
                                            :to="{name:'SliderDetails',params:{'sliderid':item.slider_id}}"
                                        >{{$t('detailsTitle')}}</b-link>
                                    </b-td>
                                </b-tr>
                            </b-tbody>

                        </b-table-simple>
                    </div>

                    <div class="text-right">
                            <span class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
                    </div>

                </b-card>
            </draggable>
        </template>

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import draggable from 'vuedraggable'


    export default {
        name: "Index",
        components: {
            Navbar,
            draggable
        },
        data() {
            return {
                ids: [],
                type: 'delete',
                items: [],
            }
        },
        methods: {
            processGroup() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'slider/delete/process/group', {
                    slider_ids: this.ids,
                    type: this.type
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getSliders();
                            this.ids = [];
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getSliders() {
                this.$Progress.start();
                Http.get(Http.apiurl() + 'slider/index')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.items = response.data.data;
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateOrder() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'slider/order/update', {
                    items: this.items
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getSliders();
                            Notificaion.success(response.data.message)

                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getSliders();
        }
    }
</script>

<style scoped>
    img{
        object-fit: contain;
    }
</style>